import {
    SimpleGrid,
    Text,
    Box,
    useColorModeValue
} from '@chakra-ui/react';
// import RR from '../Assets/Img/rr2.jpg'
import NewAvatar from './NewAvatar'

export default function Aboutme() {
    return (
        <>
            <SimpleGrid
                mx={'5%'}
                borderRadius={'2%'}
                bg={useColorModeValue('gray.50', 'gray.800')}
                columns={{ base: 1, md: 2 }}
                pb={{ base: '35%', sm: '20%', md: '1%' }}
                pt={'2%'}>
                <Box>
                    <NewAvatar />
                </Box>
                <Box
                    height={'300px'}>
                    <Text
                        textAlign={{ base: 'center', md: 'start' }}
                        fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}
                        fontWeight={'600px'}
                    >
                        <h1>About me</h1>
                        <Text
                            textAlign={{ base: 'center', md: 'start' }}
                            fontSize={{ base: '3xl', sm: '4xl', lg: '6xl' }}
                            fontWeight={'600px'}
                            color={'teal.300'}>
                            <p>I`m a Software Engineer</p>
                        </Text>
                    </Text>
                    <Text
                        textAlign={{ base: 'center', md: 'start' }}
                        fontSize={'2xl'}
                        fontWeight={"1000px"}
                        mx={{ base: '10%', sm: '5%', lg: 0 }}
                        mr={{ lg: '3%' }}>
                        <p>A 23 Years old software engineer who aspires to create and grow in the tech industry. Creative,
                            suitable web applications, and ensuring code quality, is an important value that I believe a software engineer should have.</p>
                    </Text>
                </Box>

            </SimpleGrid>
        </>
    )
}